if (!customElements.get("pack-selector")) {
  customElements.define(
    "pack-selector",
    class PackSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener("change", (event) => {
          if (event.target.matches(".pack-selector__input")) this.apply();
        });

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const fresh = event.data.html?.getElementById(this.id);
          if (!fresh) return;

          // Keep the shopper's choice when the variant (and so the prices) change.
          const selected = this.querySelector(".pack-selector__input:checked")?.value;
          this.querySelector(".pack-selector__options").innerHTML =
            fresh.querySelector(".pack-selector__options").innerHTML;
          const input = selected && this.querySelector(`.pack-selector__input[value="${selected}"]`);
          if (input) input.checked = true;
          this.apply();
        });

        // Capture phase, so this runs before product-form's own submit handler.
        this.onFormSubmit = this.onFormSubmit.bind(this);
        document.addEventListener("submit", this.onFormSubmit, true);

        this.apply();
      }

      disconnectedCallback() {
        if (typeof this.unsubscribeVariantChange === "function") this.unsubscribeVariantChange();
        document.removeEventListener("submit", this.onFormSubmit, true);
      }

      // A pack is the amount the shopper wants, not an amount to add on top:
      // /cart/add merges into an existing line (1 in cart + 2 pack = 3), so
      // drop the matching line first and then let the form add the pack.
      async onFormSubmit(event) {
        const form = event.target;
        // getAttribute: the form's `id` input shadows form.id.
        if (this.replacing || form.getAttribute("id") !== this.dataset.formId) return;

        const formData = new FormData(form);
        const variantId = Number(formData.get("id"));
        const sellingPlan = Number(formData.get("selling_plan")) || null;
        if (!variantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        try {
          const cart = await (await fetch(`${routes.cart_url}.js`)).json();
          const updates = {};
          cart.items.forEach((item) => {
            const itemPlan = item.selling_plan_allocation?.selling_plan.id || null;
            if (item.variant_id === variantId && itemPlan === sellingPlan) updates[item.key] = 0;
          });
          if (Object.keys(updates).length) {
            await fetch(`${routes.cart_update_url}.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ updates }),
            });
          }
        } catch (error) {
          console.error(error);
        }

        this.replacing = true;
        form.requestSubmit();
        this.replacing = false;
      }

      apply() {
        const input =
          this.querySelector(".pack-selector__input:checked") || this.querySelector(".pack-selector__input");
        if (!input) return;
        input.checked = true;

        const quantity = input.dataset.quantity || "1";
        const sellingPlan = input.dataset.sellingPlan || "";

        // Write into the form's own quantity field if the buy buttons render one.
        const form = document.getElementById(this.dataset.formId);
        const ownQuantity = this.querySelector("[data-pack-quantity]");
        const formQuantity = form?.querySelector('input[name="quantity"]');
        if (formQuantity) {
          formQuantity.value = quantity;
          ownQuantity.disabled = true;
        } else {
          ownQuantity.value = quantity;
        }

        const planInput = this.querySelector("[data-pack-selling-plan]");
        planInput.value = sellingPlan;
        planInput.disabled = !sellingPlan;

        this.updatePrice(input.dataset);
      }

      updatePrice({ priceFormatted, compareAtPriceFormatted, priceRaw, compareAtPriceRaw }) {
        const sectionId = this.closest("[data-section-id]")?.dataset.sectionId;
        if (!sectionId) return;

        const price = Number(priceRaw);
        const compareAtPrice = Number(compareAtPriceRaw);
        const isOnSale = compareAtPrice > price;

        [`price-${sectionId}`, `sticky-price-${sectionId}`].forEach((id) => {
          const container = document.getElementById(id)?.querySelector(".price");
          if (!container) return;

          container.classList.toggle("price--on-sale", isOnSale);
          container
            .querySelectorAll(".price__regular .wt-product__price__final, .price__sale .wt-product__price__final")
            .forEach((el) => (el.innerHTML = priceFormatted));

          const saleDiv = container.querySelector(".price__sale");
          if (saleDiv) {
            saleDiv.classList.toggle("visible", isOnSale);
            saleDiv.classList.remove("visible-main-product");
          }

          const compareEl = container.querySelector(".wt-product__price__compare");
          if (compareEl) {
            compareEl.innerHTML = isOnSale ? compareAtPriceFormatted : "";
            compareEl.classList.toggle("hidden", !isOnSale);
          }

          let percentEl = container.querySelector(".price-item--percent");
          if (!isOnSale) {
            percentEl?.remove();
            return;
          }
          if (!percentEl) {
            percentEl = document.createElement("span");
            percentEl.className = "price-item--percent";
            container.querySelector(".price__sale__details-wrapper")?.appendChild(percentEl);
          }
          percentEl.textContent = `-${Math.round(((compareAtPrice - price) / compareAtPrice) * 100)}%`;
        });
      }
    }
  );
}
